// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1ZKOQ","options":"AnswerScale_options__ZpIBe","selected":"AnswerScale_selected__2CpZ_"};